/**
 * Route for `budget-pacing-alert-burn-rate-forecasting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BudgetPacingAlertBurnRateForecastingPage } from "../features/budget-pacing-alert-burn-rate-forecasting/BudgetPacingAlertBurnRateForecastingPage";

export const budgetPacingAlertBurnRateForecastingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/budget-pacing-alert-burn-rate-forecasting",
	component: BudgetPacingAlertBurnRateForecastingPage,
});

export default budgetPacingAlertBurnRateForecastingRoute;
